import { render } from "./Introduce.vue?vue&type=template&id=d6855f00&scoped=true&ts=true"
import script from "./Introduce.vue?vue&type=script&lang=ts"
export * from "./Introduce.vue?vue&type=script&lang=ts"

import "./Introduce.vue?vue&type=style&index=0&id=d6855f00&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6855f00"]])

export default __exports__